import AcceptTOSModalModule from './accept-tos-modal.module'

export default AcceptTOSModalModule
